import {getQueryMarkup} from "../../js/endpoints/query/getQuery";

function onScroll(e){
    var containerEl = e.target;
    var markup = containerEl.dataset.markup;
    var triggerLength = containerEl.dataset.triggerLength;
    var rawQueryInfo = containerEl.dataset.query;
    var queryInfo = JSON.parse(rawQueryInfo);
    const templateNode = containerEl.querySelector('.grid-scroller__item-container').cloneNode();

    if ( containerEl.scrollLeft > triggerLength &&
        containerEl.dataset.isLoading === 'false' &&
        containerEl.dataset.isDone === 'false'
    ) {

        const spinnerNode = templateNode.cloneNode();
        const spinnerMarkup = '<div class="d-flex h-100 flex-column justify-content-center">\n' +
                                '  <div class="spinner-border text-danger" role="status">\n' +
                                '  <span class="sr-only">Loading...</span>\n' +
                                '</div>\n' +
                                '</div>';
        spinnerNode.insertAdjacentHTML('beforeend', spinnerMarkup);
        containerEl.appendChild(spinnerNode);

        containerEl.dataset.isLoading = true;


        getQueryMarkup( rawQueryInfo, markup )
            .then( res => res.json())
            .then( body => body.markup)
            .then( markup => {
                spinnerNode.remove();
                if ( markup && markup.length !== 0 ) {

                    const templateNode = containerEl.querySelector('.grid-scroller__item-container').cloneNode();

                    for (let i = 0; i < markup.length; i++) {
                        const nodeToAppend = templateNode.cloneNode();
                        nodeToAppend.insertAdjacentHTML('beforeend', markup[i]);
                        containerEl.appendChild(nodeToAppend);
                    }

                    return true;

                } else {

                    return false;

                }

            })
            .then(bool => {

                // Firing an event to run some code after the load is complete
                containerEl.dispatchEvent(new Event('aw_infinite_loading.complete', {'bubbles': true}));

                if (bool) {

                    var newMaxScrollWidth = containerEl.scrollWidth - containerEl.clientWidth;
                    queryInfo.offset = queryInfo.offset + queryInfo.posts_per_page;
                    containerEl.dataset.triggerLength =  newMaxScrollWidth - (newMaxScrollWidth - triggerLength)/2;
                    containerEl.dataset.query = JSON.stringify(queryInfo);
                    containerEl.dataset.isLoading = false;

                } else {

                    containerEl.dataset.isDone = true;
                    containerEl.removeEventListener('scroll', onScroll);
                    containerEl.removeEventListener('click.scrollVW', onScroll);

                }
            });

    }

}

var containerEls = document.querySelectorAll('.grid-scroller .grid-scroller__container');

containerEls.forEach(function(containerEl){
    const queryInfo = JSON.parse(containerEl.dataset.query);
    const maxScrollWidth = containerEl.scrollWidth - containerEl.clientWidth;

    if ( queryInfo.posts_per_page === containerEl.childElementCount ) {

        containerEl.dataset.isLoading = false;
        containerEl.dataset.isDone = false;
        containerEl.dataset.triggerLength = maxScrollWidth/2;

        queryInfo.offset = queryInfo.posts_per_page;
        queryInfo.posts_per_page = 200;
        containerEl.dataset.query = JSON.stringify(queryInfo);

        containerEl.addEventListener('scroll', onScroll);
        containerEl.addEventListener('click.scrollVW', onScroll);

    }

});
